module.exports = __webpack_public_path__ + "static/media/logoColored.9e2f703f.png";